export default {
  title: 'Kontrola dostępu: {{role}}',
  form: {
    companies: {
      label: 'Widoczne dla wszystkich członków z rolą {{role}}',
      tooltip: 'Zostanie dodane do miejsc, do których członek zespołu się zapisał',
    },
  },
  buttons: {
    save: 'Zapisz',
  },
  toasts: {
    failed_to_load_data: 'Nie udało się załadować danych, odśwież stronę',
    failed_to_save_changes: 'Nie udało się zapisać zmian',
    changes_got_saved: 'Zmiany zostały zapisane',
  },
};
